import React from 'react'
import PropTypes from 'prop-types'
import { Text, Margin } from 'shared/components'

import * as styles from './styles'

const FooterComponent = ({ currentYear, className }) => (
  <div css={styles.footer} className={className}>
    <div css={styles.menuContainer}>
      <Margin right={10} resetWhen="phone">
        <Text as="div" size={20} upper bold italic>
          Influence. Win!
        </Text>
      </Margin>
      <Margin>
        <Text as="p" css={styles.copyright}>
          &copy; {currentYear} Inwin Corporation. All rights reserved.
        </Text>
      </Margin>
    </div>
  </div>
)

FooterComponent.propTypes = {
  currentYear: PropTypes.number.isRequired,
  className: PropTypes.string,
}

export default FooterComponent
